import React from 'react';
import PageFrame from './PageFrame';
import StatCardRow from './StatCard';
import resolveTemplateHeader, { mergeFamilyHeaderChrome } from './resolveTemplateHeader';
import { ShellChromeProvider } from './ShellChromeContext';

/**
 * DashboardPageTemplate — Overview / analytical dashboard floorplan (Fiori Overview Page).
 * Status strip → optional KPI row → primary content grid/stack.
 */
const DashboardPageTemplate = ({
  children,
  className = '',
  dir,
  wide = true,
  header,
  familyHeader,
  title,
  subtitle,
  headerActions,
  toolbar,
  status,
  stats,
  statsClassName = '',
  toolbarClassName = '',
  mainClassName = '',
  content,
}) => {
  const mergedFamilyHeader = mergeFamilyHeaderChrome(familyHeader, { toolbar });
  const resolvedHeader = resolveTemplateHeader({
    header,
    familyHeader: mergedFamilyHeader,
    title,
    subtitle,
    headerActions,
  });

  return (
    <ShellChromeProvider titleOwned={Boolean(familyHeader)}>
      <PageFrame
        className={['ads-screen-dashboard', className].filter(Boolean).join(' ')}
        dir={dir}
        wide={wide}
      >
        {resolvedHeader}
        {toolbar && !familyHeader ? (
          <div
            className={['ads-screen-dashboard__toolbar', toolbarClassName].filter(Boolean).join(' ')}
          >
            {toolbar}
          </div>
        ) : null}
        {status ? <div className="ads-screen-dashboard__status">{status}</div> : null}
        {stats ? (
          <StatCardRow className={statsClassName}>{stats}</StatCardRow>
        ) : null}
        <div
          className={['ads-screen-dashboard__main', 'ads-screen-dashboard__main--stack', mainClassName]
            .filter(Boolean)
            .join(' ')}
        >
          {content ?? children}
        </div>
      </PageFrame>
    </ShellChromeProvider>
  );
};

export default DashboardPageTemplate;
